var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTriangleDownFilledHovered(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "black",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 0C1.79086 0 0 1.79086 0 4V12C0 14.2091 1.79086 16 4 16H12C14.2091 16 16 14.2091 16 12V4C16 1.79086 14.2091 0 12 0H4ZM12.7818 6.62475C13.3057 5.97 12.8395 5 12.001 5H4.0005C3.16196 5 2.6958 5.97 3.21967 6.62475L7.21991 11.6243C7.62024 12.1247 8.38124 12.1247 8.78156 11.6243L12.7818 6.62475Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTriangleDownFilledHovered);
export default __webpack_public_path__ + "static/media/triangle-down-filled-hovered.a9c4665b8c508cfbc86b8c3b376d6bca.svg";
export { ForwardRef as ReactComponent };